export default __webpack_public_path__ + "static/media/handwovenpunja.dd47ff87.jpg";